import React from "react";
import LotusLogo from "./Logo";
import { Wrapper } from "../styles/components/Global/Global";
import {
  BannerContainer,
  Item,
  LogoWrapper,
} from "../styles/components/Global/Heading";
import { Banner } from "../styles/components/Global/Text";

const LotusBanner = () => {
  return (
    <Wrapper>
      <BannerContainer>
        <Item>
          <Banner>48.8566° N, 2.3522° E</Banner>
        </Item>
        <Item>
          <LotusLogo
            source="https://www.datocms-assets.com/40484/1694885842-logo-wordmark.png"
            small={true}
            link={true}
          />
        </Item>
        <Item>
          <Banner $heading>Ksawery</Banner>
        </Item>
      </BannerContainer>
      <LogoWrapper>
        <LotusLogo
          source="https://www.datocms-assets.com/40484/1695229066-lotus-logo.png"
          link={true}
        />
      </LogoWrapper>
    </Wrapper>
  );
};

export default LotusBanner;
